/**
 * @fileoverview Browser history instance for React Router navigation.
 */

import {createBrowserHistory} from "history";

/**
 * Browser history instance used throughout the application for navigation.
 */
export const history = createBrowserHistory();
